import config from 'config';

// Import the BlogArticle component

const Home = () => import(/* webpackChunkName: "vsf-home" */ 'theme/pages/Home.vue');
const PageNotFound = () => import(/* webpackChunkName: "vsf-not-found" */ 'theme/pages/PageNotFound.vue');
const PassReset = () => import(/* webpackChunkName: "vsf-not-found" */ 'theme/pages/PassReset.vue');
const OrderResult = () =>
  import(/* webpackChunkName: "vsf-order-result" */ 'theme/components/theme/anyrent/OrderResult.vue');
const ErrorPage = () => import(/* webpackChunkName: "vsf-error" */ 'theme/pages/Error.vue');
const Product = () => import(/* webpackChunkName: "vsf-product" */ 'theme/pages/Product.vue');
const Category = () => import(/* webpackChunkName: "vsf-category" */ 'theme/pages/Category.vue');
const CmsPage = () => import(/* webpackChunkName: "vsf-cms" */ 'theme/pages/CmsPage.vue');
const Checkout = () => import(/* webpackChunkName: "vsf-checkout" */ 'theme/pages/Checkout.vue');
const Compare = () => import(/* webpackChunkName: "vsf-compare" */ 'theme/pages/Compare.vue');
const MyAccount = () => import(/* webpackChunkName: "vsf-my-account" */ 'theme/pages/MyAccount.vue');
const Static = () => import(/* webpackChunkName: "vsf-static" */ 'theme/pages/Static.vue');
const Test = () => import(/* webpackChunkName: "vsf-test" */ 'theme/pages/Test.vue');
const BlogListing = () => import(/* webpackChunkName: "vsf-blog-listing" */ 'theme/pages/blog/BlogListing.vue');
const BlogArticle = () => import(/* webpackChunkName: "vsf-blog-article" */ 'theme/pages/blog/BlogArticle.vue');
const BlogHomepage = () => import(/* webpackChunkName: "vsf-blog-homepage" */ 'theme/pages/blog/BlogHomepage.vue');

const routes = [
  { name: 'home', path: '/', component: Home, alias: '/pwa.html' },
  { name: 'checkout', path: '/checkout', component: Checkout },
  { name: 'my-account', path: '/my-account', component: MyAccount },
  {
    name: 'my-shipping-details',
    path: '/my-account/shipping-details',
    component: MyAccount,
    props: { activeBlock: 'MyShippingDetails' }
  },
  {
    name: 'my-newsletter',
    path: '/my-account/newsletter',
    component: MyAccount,
    props: { activeBlock: 'MyNewsletter' }
  },
  { name: 'my-orders', path: '/my-account/orders', component: MyAccount, props: { activeBlock: 'MyOrders' } },
  { name: 'my-order', path: '/my-account/orders/:orderId', component: MyAccount, props: { activeBlock: 'MyOrder' } },
  {
    name: 'my-recently-viewed',
    path: '/my-account/recently-viewed',
    component: MyAccount,
    props: { activeBlock: 'MyRecentlyViewed' }
  },
  { name: 'compare', path: '/compare', component: Compare, props: { title: 'Compare Products' } },
  { name: 'virtual-product', path: '/p/:parentSku/:slug', component: Product }, // :sku param can be marked as optional with ":sku?" (https://github.com/vuejs/vue-router/blob/dev/examples/route-matching/app.js#L16), but it requires a lot of work to adjust the rest of the site
  { name: 'bundle-product', path: '/p/:parentSku/:slug', component: Product }, // :sku param can be marked as optional with ":sku?" (https://github.com/vuejs/vue-router/blob/dev/examples/route-matching/app.js#L16), but it requires a lot of work to adjust the rest of the site
  { name: 'simple-product', path: '/p/:parentSku/:slug', component: Product }, // :sku param can be marked as optional with ":sku?" (https://github.com/vuejs/vue-router/blob/dev/examples/route-matching/app.js#L16), but it requires a lot of work to adjust the rest of the site
  { name: 'downloadable-product', path: '/p/:parentSku/:slug', component: Product }, // :sku param can be marked as optional with ":sku?" (https://github.com/vuejs/vue-router/blob/dev/examples/route-matching/app.js#L16), but it requires a lot of work to adjust the rest of the site
  { name: 'grouped-product', path: '/p/:parentSku/:slug', component: Product }, // :sku param can be marked as optional with ":sku?" (https://github.com/vuejs/vue-router/blob/dev/examples/route-matching/app.js#L16), but it requires a lot of work to adjust the rest of the site
  { name: 'configurable-product', path: '/p/:parentSku/:slug/:childSku', component: Product }, // :sku param can be marked as optional with ":sku?" (https://github.com/vuejs/vue-router/blob/dev/examples/route-matching/app.js#L16), but it requires a lot of work to adjust the rest of the site
  { name: 'product', path: '/p/:parentSku/:slug/:childSku', component: Product }, // :sku param can be marked as optional with ":sku?" (https://github.com/vuejs/vue-router/blob/dev/examples/route-matching/app.js#L16), but it requires a lot of work to adjust the rest of the site
  { name: 'category', path: '/c/:slug', component: Category },
  { name: 'cms-page', path: '/i/:slug', component: CmsPage },
  { name: 'reset-pass', path: '/passreset', component: PassReset },
  { name: 'order-result', path: '/order', component: OrderResult },
  { name: 'error', path: '/error', component: ErrorPage, meta: { layout: 'minimal' } },
  {
    name: 'blog',
    path: '/blog',
    component: BlogHomepage
  },

  // static pages
  { name: 'static', path: '/static/*', component: Static },

  ...(config.app.env === 'production' ? [] : [{ name: 'test-page', path: '/test', component: Test }]),

  { name: 'page-not-found', path: '*', component: PageNotFound },
  {
    name: 'blog-homepage',
    path: '/blog',
    component: BlogHomepage,
    meta: {
      title: 'Blog'
    }
  },
  {
    name: 'blog-category',
    path: '/blog/:categorySlug',
    component: BlogListing,
    meta: {
      title: 'Blog Category'
    },
    props: route => ({ category: route.params.categorySlug })
  },
  {
    name: 'blog-article',
    path: '/blog/:categorySlug/:articleSlug',
    component: BlogArticle,
    meta: {
      title: 'Blog Article'
    }
  }
];

export default routes;
